import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { InteractionToolBehavior } from '../../canvas/tooling/InteractionToolBehavior';
import { EraserToolBehavior } from './EraserTool';
import { MarkerToolBehavior } from './MarkerToolBehavior';

export const markerTool = defineToolWithCommonBehaviors({
    id: 'markerTool',
    label: 'Marker',
    category: 'collaboration',
    icon: 'deqo://icons/d2/draw',
    weight: 1070,
    shortcut: 'M',
    behaviors: [
        EraserToolBehavior('passive'),
        MarkerToolBehavior,
        InteractionToolBehavior,
    ]
});
